import React from 'react';
import { useSelector } from 'react-redux';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { TrustBanner } from '@noths/polaris-design-system-candidate-components';

import { selectTrustBannerContent } from 'src/redux/content/selectors';
import { trackTrustBannerImpression } from '../tracking/trustBannerEvents';

export const TrustBannerWithTracking = () => {
  const content = useSelector(selectTrustBannerContent);
  const impressionRef = useImpressionRef<HTMLDivElement>(() => {
    if (content) {
      trackTrustBannerImpression(content.trackingTitle || content.headline);
    }
  });

  if (!content) {
    return null;
  }

  const { trackingTitle, ...trustBannerProps } = content;

  return (
    <div ref={impressionRef}>
      <TrustBanner {...trustBannerProps} />
    </div>
  );
};
